import { Heading, Text } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { PageContent } from "../PageContent";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { getNameFromUser } from "shared/utils";
import { useAppContext } from "AppContext";
import { EmptyState } from "shared/components/root";
import { useDoorstopLayout } from "./useDoorstopLayout";
import { Collapsible } from "shared/components/molecules";
import { css } from "styled-system/css";

type DoorstopLayoutProps = PropsWithChildren & {
  operatorsOnly?: boolean;
};

export const DoorstopLayout = ({
  children,
  operatorsOnly,
}: DoorstopLayoutProps) => {
  const { t } = useTranslation();
  const {
    isSendingEmailVerification,
    showEmailVerificationPrompt,
    handleSendVerificationEmail,
  } = useDoorstopLayout();

  const {
    dbUser,
    organizationsError,
    organizationsLoading,
    operatorsError,
    operatorsLoading,
  } = useAppContext();
  return (
    <Flex
      flexDir="column"
      alignItems={"center"}
      gap="600"
      py="1000"
      px="60px"
      backgroundColor="bg.wa.light"
      height="full"
      overflowY={"auto"}
    >
      {/* EMAIL VERIFICATION */}
      <Collapsible
        open={showEmailVerificationPrompt}
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
        contentContainerClassName={css({
          width: "full",
          maxW: "800px",
        })}
      >
        <EmptyState
          text={t("core:DOORSTOP.VERIFY_EMAIL.MESSAGE")}
          ctaButtonProps={{
            isLoading: isSendingEmailVerification,
            visual: "accent.blue",
            onClick: handleSendVerificationEmail,
            children: t("core:DOORSTOP.VERIFY_EMAIL.BUTTON_CTA"),
          }}
          width="full"
          maxW="800px"
        />
      </Collapsible>

      <Flex
        flexDir="column"
        alignItems={"center"}
        justifyContent={"center"}
        gap="50"
        maxW="500px"
      >
        <Heading size="h3">👋</Heading>
        <Heading size="h5">
          {t("core:DOORSTOP.HI")}, {getNameFromUser(dbUser!)}!
        </Heading>
        <Text visual="bodyRegular" textAlign="center" pt="100">
          {operatorsOnly
            ? t("core:DOORSTOP.OPERATOR_ONLY_DESCRIPTION")
            : t("core:DOORSTOP.DESCRIPTION")}
        </Text>
      </Flex>
      <PageContent
        loading={operatorsLoading || organizationsLoading}
        throwAppError={
          operatorsError || organizationsError
            ? "Could not load user's operators/organizations"
            : undefined
        }
      >
        {children}
      </PageContent>
    </Flex>
  );
};
